import React from 'react';
import {Atom, withSystem, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {UsysUtilityPageConstraint, extraAttrs} from './utils';
import {
  USYS_INPUT_TYPES,
  USYS_DATA_ATTRS,
} from '@packages/systems/users/constants';
import {TText, TRecord} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const UserFormPasswordInput = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const inputClasses = classes.push('w-input');
    return (
      <input
        {...generateAttributes(attributes, inputClasses)}
        type="password"
        required
        {...{[USYS_DATA_ATTRS.inputType]: USYS_INPUT_TYPES.password}}
      />
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'User Password Field',
  constraints: {
    page: [UsysUtilityPageConstraint],
    ancestors: [
      {
        is: ['UserSignUpForm', 'UserUpdatePasswordForm', 'UserLogInForm'],
        name: 'User Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: UserFormPasswordInput,
  fields: {
    attr: TRecord(
      {
        placeholder: withSystem(
          {label: 'Placeholder', isFullWidth: true},
          TText
        ),
      },
      extraAttrs
    ),
  },
});

export default config;
